export default __webpack_public_path__ + "media/images/react_icons/empty_reservations-1835ed448fa60f60de7d478891d87c52.svg";